import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_LG, MODAL_md, MODAL_XL } from '../../../theme/Component/hooks/useModal';
import { _SIIFTCON17Value } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { SiifAuxiliaryCatalogSelect } from '../SIIFAuxiliaryCatalog/SiifAuxiliaryCatalogSelect';
import { BasicButton } from '../../../theme/Component/BasicButton';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const SIIFTCON17Editor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_SIIFTCON17Value)
    const [id, setID] = useState(null);
    const [SIIFAuxiliary, setSIIFAuxiliary] = useState<number>(null)
    const modal = useModal("Auxiliares TCon17", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDSIIFTCON17Value == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    useEffect(() => {
        getLista();
    }, [SIIFAuxiliary])

    const getLista = () => {

        instance.getSIIFTCON17ValueByIDSIIFAuxiliary(SIIFAuxiliary).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDSIIFTCON17Value', visible: true },
        { title: 'Auxiliar', property: 'SIIFAuxiliaryName', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Auxiliares TCon17"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <SiifAuxiliaryCatalogSelect label='Auxiliar' idSelector={SIIFAuxiliary} onChange={(e) => { setSIIFAuxiliary(e) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDSIIFTCON17Value); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}